import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface SaleOffer {
  text: string;
  price: string;
  image: string;
  probability: number;
}
const saleOffers: SaleOffer[] = [{
  text: 'Buy 3, Get 2 Free',
  price: '$89.97',
  image: 'https://cdn.magicpatterns.com/uploads/ikigb4DaYP29E1GRJ6x2Y6/Generated_Image_December_22,_2025_-_7_10PM.png',
  probability: 0.45 // 45%
}, {
  text: 'Buy 2, Get 1 Free',
  price: '$59.98',
  image: 'https://cdn.magicpatterns.com/uploads/nB1NbtSHBQy6Wka4AzbbBt/Generated_Image_December_22,_2025_-_4_26PM.png',
  probability: 0.3 // 30%
}, {
  text: 'Single Bottle',
  price: '$29.99',
  image: 'https://cdn.magicpatterns.com/uploads/sCzJPCpJhc9zMT9yg88sL6/Generated_Image_December_22,_2025_-_7_24PM.png',
  probability: 0.25 // 25%
}];
const firstNames = ['Mia', 'Liam', 'Emma', 'Noah', 'Olivia', 'Ethan', 'Ava', 'Lucas', 'Sophia', 'Mason', 'Isabella', 'Logan', 'Charlotte', 'Jackson', 'Amelia', 'Aiden', 'Harper', 'Elijah', 'Evelyn', 'James', 'Abigail', 'Benjamin', 'Emily', 'William', 'Ella', 'Michael', 'Scarlett', 'Alexander', 'Grace', 'Daniel', 'Chloe', 'Henry', 'Victoria', 'Matthew', 'Madison', 'David'];
const locations = ['Denver', 'Austin', 'Seattle', 'Portland', 'Phoenix', 'San Diego', 'Boston', 'Nashville', 'Charlotte', 'Atlanta', 'Miami', 'Dallas', 'Chicago', 'Houston', 'Philadelphia', 'San Antonio', 'Minneapolis', 'Tampa', 'Orlando', 'Detroit', 'Las Vegas', 'Baltimore', 'Sacramento', 'Kansas City', 'Cleveland', 'Indianapolis', 'Columbus', 'San Jose'];
function getRandomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}
function getWeightedRandomOffer(): SaleOffer {
  const random = Math.random();
  let cumulativeProbability = 0;
  for (const offer of saleOffers) {
    cumulativeProbability += offer.probability;
    if (random <= cumulativeProbability) {
      return offer;
    }
  }
  return saleOffers[0]; // Fallback
}
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');
  const [currentOffer, setCurrentOffer] = useState<SaleOffer>(saleOffers[0]);
  useEffect(() => {
    const showNotification = () => {
      setCurrentName(getRandomItem(firstNames));
      setCurrentLocation(getRandomItem(locations));
      setCurrentOffer(getWeightedRandomOffer());
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimeout = setTimeout(showNotification, 5000);
    const interval = setInterval(showNotification, 10000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-1273">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 30,
      scale: 0.9
    }} transition={{
      duration: 0.5,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-4 sm:bottom-6 left-4 right-4 z-50 mx-auto max-w-xs" data-id="element-1274">
          <div className="relative bg-white/95 backdrop-blur-xl rounded-xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.12),0_2px_8px_rgba(0,0,0,0.08)]" data-id="element-1275">
            {/* Subtle gradient border effect */}
            <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-ginger/20 via-transparent to-ginger/10 opacity-50" style={{
          padding: '1px'
        }} data-id="element-1276">
              <div className="w-full h-full bg-white rounded-xl" data-id="element-1277" />
            </div>

            {/* Content */}
            <div className="relative flex items-center gap-2.5 p-3" data-id="element-1278">
              {/* Product Image - smaller */}
              <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden shadow-md ring-1 ring-black/5" data-id="element-1279">
                <img src={currentOffer.image} alt="GINEXT Product" className="w-full h-full object-cover" data-id="element-1280" />
              </div>

              {/* Text Content - smaller fonts */}
              <div className="flex-1 min-w-0" data-id="element-1281">
                <p className="text-xs font-light text-charcoal/90 mb-0.5 leading-snug" data-id="element-1282">
                  <span className="font-medium" data-id="element-1283">{currentName}</span> from{' '}
                  <span className="font-medium" data-id="element-1284">{currentLocation}</span>
                </p>
                <p className="text-xs font-light text-charcoal/80 mb-0.5" data-id="element-1285">
                  just purchased{' '}
                  <span className="text-ginger font-medium" data-id="element-1286">GINEXT</span>
                </p>
                <p className="text-[10px] text-charcoal-light/90 leading-relaxed" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1287">
                  {currentOffer.text} –{' '}
                  <span className="font-medium" data-id="element-1288">{currentOffer.price}</span>
                </p>
              </div>
            </div>

            {/* Subtle bottom accent */}
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-ginger/30 to-transparent" data-id="element-1289" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}